<template>
  <div class="max-w-screen-md mx-auto px-4">
    <AnimatedElement>
      <h2 class="text-center text-4xl mb-24">Shops</h2>
    </AnimatedElement>
    <div v-if="loading">
      <FlowerIcon name="flower" class="w-12 h-12 animate-spin mx-auto" />
    </div>
    <div v-else class="grid gap-y-20">
      <AnimatedElement 
        v-for="post in posts" 
        :key="post.id" 
        animation="animate__fadeInLeft"
        class="grid grid-cols-2 gap-x-6 lg:gap-x-12"
      >
        <img 
          class="rounded-full aspect-square object-cover max-w-auto w-100 h-100" 
          :src="post.image"
          loading="lazy"
        />
        <div class="grid content-center text-center">
          <h2 class="text-2xl mb-2">{{ post.title }}</h2>
          <div v-html="post.excerpt"></div>
        </div>
      </AnimatedElement>
    </div>
  </div>
</template>
  
<script>
import axios from "axios";
import AnimatedElement from "./AnimatedElement.vue";
import FlowerIcon from "./FlowerIcon.vue";

export default {
  components: {
    AnimatedElement,
    FlowerIcon,
  },
  data() {
    return {
      posts: [],
      loading: true,
    };
  },
  mounted() {
    axios
    .get(process.env.VUE_APP_CMS_API_URL + 'shops?_embed')
    .then((response) => {
      this.posts = response.data.map((post) => ({
        id: post.id,
        title: post.title.rendered,
        excerpt: post.excerpt.rendered,
        image: post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
      }));

      const imagePromises = this.posts.map((post) => {
        return new Promise((resolve) => {
          if (post.image) {
            const img = new Image();
            img.src = post.image;
            img.onload = resolve;
            img.onerror = resolve; // Resolve even if the image fails to load
          } else {
            resolve(); // No image to load
          }
        });
      });

      Promise.all(imagePromises)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error loading images:", error);
          this.loading = false; // Fail-safe
        });
    })
    .catch((error) => {
      console.error("Error fetching posts:", error);
      this.loading = false;
    });
  }

};
</script>
